<div class="header-inline-field-container">

  @if (!editMode) {
    <div class="field-container fx-layout-row fx-wrap fx-justify-start fx-align-baseline">
      <div (click)="makeEditable()" (keyup.enter)="makeEditable()" [ngClass]="{'disabled': disabled}"
        class="read-value" tabindex="0">
        <span (click)="makeEditable()" class="inline-edit-value selectable">
          {{ control?.value }}
        </span>
        @if (!disabled) {
          <div (click)="makeEditable()" class="inline-edit-content">
            <span class="overlay-icon">
              <mat-icon fontSet="mdi" fontIcon="mdi-pencil" class="selectable"></mat-icon>
            </span>
          </div>
        }
      </div>
    </div>
  }

  @if (editMode && !disabled) {
    <div class="field-container fx-flex-100-percent fx-layout-col">
      <form autocomplete="off">
        <mat-form-field appearance="outline" [floatLabel]="'auto'">
          <input #inputField (keyup.enter)="onKey($event)" (keyup.escape)="onKey($event)"
            [formControl]="control" class="edit-value" matInput type="text">
          @for (validator of validators; track validator.type) {
            <mat-error class="small-font">
              @if (control.hasError(validator.type)) {
                <span>
                  {{ 'ERROR.FIELD_' + validator.type | uppercase | translate: {value: validator.definition} }}
                </span>
              }
            </mat-error>
          }
          @if (control.hasError('required')) {
            <mat-error class="small-font text-danger support-text">
              {{'ERROR.FIELD_REQUIRED' | translate}}
            </mat-error>
          }
          @if (control.hasError('isValueTaken')) {
            <mat-error class="small-font text-danger support-text">
              {{'ERROR.CLIENT_NAME_ALREADY_IN_USE' | translate}}
            </mat-error>
          }
          @if (control.hasError('maxlength')) {
            <mat-error class="small-font text-danger support-text">
              {{ 'ERROR.FIELD_MAX_LENGTH' | translate:{ value: appConfig.NAME_MAX_LENGTH } }}
            </mat-error>
          }
        </mat-form-field>
      </form>
      @if (editMode) {
        <div class="save-options">
          <button (click)="cancelEditable()" (keyup.escape)="onKey($event)" class="button">
            <mat-icon fontSet="mdi" fontIcon="mdi-close"></mat-icon>
          </button>
          <button (click)="callSave()" (keyup.escape)="onKey($event)" [disabled]="preventSave()"
            class="button save">
            <mat-icon fontSet="mdi" fontIcon="mdi-check"></mat-icon>
          </button>
        </div>
      }
    </div>
  }
</div>
